import ChangePasswordPage from "./change-password.page";

export default ChangePasswordPage;
